import React from "react";

interface Props {
  className?: string;
  width?: string;
  height?: string;
  color?: string;
}

const OutlinedRouting = (props: Props) => {
  const { className, width = "18", height = "18", color = "#308CDB" } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.55838 7.95832C2.96671 7.95832 2.36671 7.74166 1.90838 7.29999C0.375048 5.84166 -0.241619 4.24999 0.116714 2.69166C0.541714 0.858323 2.15005 0.0416565 3.55838 0.0416565C4.96671 0.0416565 6.58338 0.866656 7.00005 2.69166C7.35838 4.24999 6.73338 5.84166 5.20838 7.29999C4.75005 7.74166 4.15838 7.95832 3.55838 7.95832ZM1.33338 2.97499C1.01671 4.36666 1.94171 5.59999 2.77505 6.39166C3.21671 6.81666 3.90838 6.80832 4.35005 6.39166C5.18338 5.59999 6.10838 4.36666 5.78338 2.96666C5.50005 1.73332 4.40838 1.29166 3.56671 1.29166C2.71671 1.29166 1.62505 1.73332 1.33338 2.97499Z"
        fill={color}
      />
      <path
        d="M3.59139 4.16682C3.13306 4.16682 2.75806 3.79182 2.75806 3.33349C2.75806 2.87515 3.12472 2.50015 3.59139 2.50015H3.59972C4.05806 2.50015 4.43306 2.87515 4.43306 3.33349C4.43306 3.79182 4.05806 4.16682 3.59139 4.16682Z"
        fill={color}
      />
      <path
        d="M14.4081 17.9585C13.8165 17.9585 13.2165 17.7419 12.7498 17.3002C11.2081 15.8419 10.5831 14.2502 10.9498 12.6835C11.3748 10.8585 12.9915 10.0335 14.4081 10.0335C15.8248 10.0335 17.4415 10.8585 17.8665 12.6835C18.2248 14.2419 17.5998 15.8419 16.0581 17.2919C15.5998 17.7419 15.0081 17.9585 14.4081 17.9585ZM14.4081 11.2919C13.5581 11.2919 12.4581 11.7335 12.1665 12.9752C11.8415 14.3669 12.7748 15.6085 13.6081 16.4002C14.0498 16.8252 14.7498 16.8252 15.1998 16.4002C16.0331 15.6085 16.9665 14.3752 16.6415 12.9835C16.3665 11.7335 15.2665 11.2919 14.4081 11.2919Z"
        fill={color}
      />
      <path
        d="M14.4414 14.1668C13.9831 14.1668 13.6081 13.7918 13.6081 13.3335C13.6081 12.8752 13.9747 12.5002 14.4414 12.5002H14.4497C14.9081 12.5002 15.2831 12.8752 15.2831 13.3335C15.2831 13.7918 14.8997 14.1668 14.4414 14.1668Z"
        fill={color}
      />
      <path
        d="M8.99987 15.4583H6.76654C5.79987 15.4583 4.9582 14.875 4.62487 13.975C4.2832 13.075 4.5332 12.0833 5.2582 11.4417L11.9165 5.61666C12.3165 5.26666 12.3249 4.79166 12.2082 4.46666C12.0832 4.14166 11.7665 3.79166 11.2332 3.79166H8.99987C8.6582 3.79166 8.37487 3.50832 8.37487 3.16666C8.37487 2.82499 8.6582 2.54166 8.99987 2.54166H11.2332C12.1999 2.54166 13.0415 3.12499 13.3749 4.02499C13.7165 4.92499 13.4665 5.91666 12.7415 6.55832L6.0832 12.3833C5.6832 12.7333 5.67487 13.2083 5.79153 13.5333C5.91653 13.8583 6.2332 14.2083 6.76654 14.2083H8.99987C9.34153 14.2083 9.62487 14.4917 9.62487 14.8333C9.62487 15.175 9.34153 15.4583 8.99987 15.4583Z"
        fill={color}
      />
      <path
        d="M8.99987 15.4583H6.76654C5.79987 15.4583 4.9582 14.875 4.62487 13.975C4.2832 13.075 4.5332 12.0833 5.2582 11.4417L11.9165 5.61666C12.3165 5.26666 12.3249 4.79166 12.2082 4.46666C12.0832 4.14166 11.7665 3.79166 11.2332 3.79166H8.99987C8.6582 3.79166 8.37487 3.50832 8.37487 3.16666C8.37487 2.82499 8.6582 2.54166 8.99987 2.54166H11.2332C12.1999 2.54166 13.0415 3.12499 13.3749 4.02499C13.7165 4.92499 13.4665 5.91666 12.7415 6.55832L6.0832 12.3833C5.6832 12.7333 5.67487 13.2083 5.79153 13.5333C5.91653 13.8583 6.2332 14.2083 6.76654 14.2083H8.99987C9.34153 14.2083 9.62487 14.4917 9.62487 14.8333C9.62487 15.175 9.34153 15.4583 8.99987 15.4583Z"
        fill={color}
      />
    </svg>
  );
};

export default OutlinedRouting;
